import { POSMaterial, POSMaterialSaveObject } from './POSMaterial';
import { Utils } from '../../../core/services/utils.service';

export interface POSMaterialTextSaveObject extends POSMaterialSaveObject {
	color: string;
	fontSize: number;
}

export class POSTextMaterial extends POSMaterial {

	private _color: string;
	private _fontSize: number;

	public set color(color: string) {
		this._color = color ?? '#000000';
	}

	public get color(): string {
		return this._color;
	}

	public set fontSize(fontSize: number) {
		this._fontSize = fontSize ?? 16;
	}

	public get fontSize(): number {
		return this._fontSize;
	}

	public get height(): number {
		const canvas: HTMLCanvasElement = document.createElement('canvas');
		const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
		if (!ctx) return this._fontSize / 520;

		const maxWidth: number = this.width * 2;
		const fontSizePx: number = (this._fontSize * window.devicePixelRatio) / 380;
		ctx.font = `${fontSizePx}px sans-serif`;

		const words: string[] = this.name.split(' ');
		const lines: string[] = [];
		let line: string = '';

		for (let w: number = 0; w < words.length; w++) {
			const word: string = words[w];
			const testLine: string = line + word + ' ';
			const metrics: TextMetrics = ctx.measureText(testLine);

			if (metrics.width <= maxWidth) {
				line = testLine;
			} else {
				if (line !== '') {
					lines.push(line.trim());
					line = '';
				}

				let subLine: string = '';
				for (let i: number = 0; i < word.length; i++) {
					const char: string = word[i];
					const testSubLine: string = subLine + char;
					const subMetrics: TextMetrics = ctx.measureText(testSubLine);

					if (subMetrics.width > maxWidth) {
						if (subLine.length > 0) {
							lines.push(subLine);
						}
						subLine = char;
					} else {
						subLine = testSubLine;
					}
				}

				if (subLine.length > 0) {
					line = subLine + ' ';
				} else {
					line = '';
				}
			}
		}
		if (line !== '') {
			lines.push(line.trim());
		}

		const lineHeight: number = fontSizePx * 1.2;
		const totalHeight: number = lines.length * lineHeight;

		return totalHeight / 520;
	}

	constructor(params: Partial<POSMaterialTextSaveObject> = {}) {
		if (Utils.isNullOrUndefined(params.name)) params.name = 'Text';
		super(params);

		this.color = params.color;
		this.fontSize = params.fontSize;
	}

	public copy(): POSTextMaterial {
		return new POSTextMaterial(this.saveObject());
	}

	public saveObject(): POSMaterialTextSaveObject {
		return {
			...super.saveObject(),
			color: this.color,
			fontSize: this.fontSize
		}
	}
}